import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wind02 = function Wind02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9.5093 4.6667A1.995 1.995 0 0 1 11 4c1.1046 0 2 .8954 2 2s-.8954 2-2 2H2m10.5093 11.3333A1.995 1.995 0 0 0 14 20c1.1046 0 2-.8954 2-2s-.8954-2-2-2H2m14.764-9c.5493-.6137 1.3476-1 2.2361-1 1.6569 0 3 1.3431 3 3s-1.3431 3-3 3H2"
    })
  }));
};
export default Wind02;